//CRN_20251218 - ⚠️ Avoid using this service prior to an R&D Team discussion ⚠️

import { ExceptionsService } from './utelize/general/exceptions-service';
import { Injectable } from '@angular/core';
import { map, filter } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

interface Event {
  type    : string;
  payload?: any;
}

type EventCallback=(payload: any) => void;

@Injectable({
  providedIn: 'root'
})

export class EventService {

  private handler=new Subject<Event>();
  
  constructor(
    private exceptionsService: ExceptionsService
  ) { }
  
  public broadcast(type: string, payload={}) {
    try {
      this.handler.next({ type, payload });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private subscribe(type: string, callback: EventCallback): Subscription | undefined {
    try {
      return this.handler
             .pipe(filter(event => event.type===type))
             .pipe(map(event => event.payload))
             .subscribe(callback);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }
}
